/**
 * Where a make purchase order's materials stand on Manufacturing Materials picking lists
 * (PickListChangeViewModel in the API): the 400 body of a refused requirement or line change, and
 * the answer to the line-quantity pre-flight. Switch on `code` (null = on no list) and word the
 * message in $localize - the API deliberately sends no sentence.
 */
export interface PickListChange {
  code: string | null;
  /** Every list in the deciding state, lowest number first. */
  pickListNumbers: string[];
  /** Who to tell: the user who printed each list, or who created it. */
  owner: string;
  /** The change adds material, so the completed-list path asks about a new picking list. */
  addsMaterial: boolean;
  purchaseOrderHeaderIds: string[];
}

/** Must match PickListChangeCodes in the API (TMSWeb.Common/Constants). */
export const PickListChangeCodes = {
  pickListPrinted: 'PickListPrinted',
  pickListNotPrinted: 'PickListNotPrinted',
  pickListComplete: 'PickListComplete',
} as const;
